import { setIdReduxAction } from '../../../../redux/actions/set-id'
import WORKOUTS_ACTION from '../../constants/action'
import WORKOUTS_PATH from '../../constants/path'

function setStartedWorkoutAction (instance) {
  return setIdReduxAction({
    type: instance
      ? WORKOUTS_ACTION.UPDATE_STARTED
      : WORKOUTS_ACTION.RESET_STARTED,
    payload: {
      path: WORKOUTS_PATH.STARTED,
      instance
    }
  })
}

export default setStartedWorkoutAction
